




































import {
    Component, Prop, Vue, ComparisonProduct, ComponentStyle,
    ComponentStyleDefinition, VueComponent, InjectComponent
} from "@zoovu/runner-browser-api";

@Component({})
export default class AlternativeProductsView extends Vue {

    @Prop()
    alternativeProducts: ComparisonProduct[];

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("ProductPriceView")
    productPriceView: VueComponent;

    alternativeProductsExpanded = false;
    fading = false;

    mounted() {
        this.$root.$refs.alternativeContainer = this.$refs.alternativeContainer;
    }

    fadeOutClass(): string {
        return this.fading ? 'fade-out' : '';
    }

    async toggleAlternativeProducts() {
        let container = (this.$refs.alternativeContainer as HTMLElement);
        if (container) {
            this.fading = true;
            this.$emit("toggle-alternative-products", false);

            await this.$nextTick();
            this.alternativeProductsExpanded = !this.alternativeProductsExpanded;

        } else {
            this.fading = false;
            this.$emit("toggle-alternative-products", true);
            this.alternativeProductsExpanded = !this.alternativeProductsExpanded;
        }
    }

    alternativeProductRemoved(product) {
        this.alternativeProducts.splice(this.alternativeProducts.lastIndexOf(product), 1);
        this.$emit("alternative-product-removed", product);
    }
}
